<template>
  <div>
    <div>
      <vxe-grid
        ref="table"
        show-overflow
        :loading="loading"
        :data="tableData"
        :height="350"
        :columns="tableColumns"
        :toolbar-config="tableToolbar"
        :radio-config="{
          trigger: 'row',
          highlight: true,
        }"
        row-key
        size="small"
        resizable
        border
      >
        <template v-slot:toolbar_form>
          <slot name="header">
            <b-form onsubmit="return false">
              <b-input-group size="sm">
                <el-select
                  v-model="coolerCode"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  :disabled="disabled"
                  placeholder="请输入冷藏箱编号"
                  :remote-method="queryCoolers"
                >
                  <el-option
                    v-for="item in coolerOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <b-button
                  size="sm"
                  class="ml-2"
                  variant="outline-success"
                  :disabled="disabled"
                  @click="addCooler()"
                >
                  <b-icon-plus></b-icon-plus>新增
                </b-button>
              </b-input-group>
            </b-form>
          </slot>
        </template>
        <template v-slot:opt="{ row }">
          <div>
            <el-tooltip
              class="item"
              effect="dark"
              content="查看"
              placement="top"
            >
              <i
                class="el-icon-view tool-btn"
                @click="
                  () =>
                    $emit('openEditFormDialog', {
                      coolerCode: row.coolerCode,
                      coolerNo: row.coolerNo,
                      type: 'detail',
                    })
                "
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
              v-if="!disabled"
            >
              <i
                class="el-icon-edit tool-btn"
                @click="
                  () =>
                    $emit('openEditFormDialog', {
                      coolerCode: row.coolerCode,
                      coolerNo: row.coolerNo,
                      type: 'edit',
                    })
                "
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              v-if="!disabled"
            >
              <i class="el-icon-delete tool-btn" @click="deleteCooler(row)"></i>
            </el-tooltip>
          </div>
        </template>
      </vxe-grid>
    </div>
  </div>
</template>
<script>
import tableColumns from './cooler-table-columns'
export default {
  props: {
    dispatchOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      coolerOptions: [],
      listCooler: [],
      coolerCode: '',
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      await this.loadPackData()
      await this.loadCoolers()
      this.loading = false
    },
    async loadPackData() {
      if (!this.dispatchOrderCode) return
      await this.$api
        .carrierWaybillSelectCoolerApi({
          dispatchOrderCode: this.dispatchOrderCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async loadCoolers() {
      await this.$api.carrieGetCoolerNotUseSelectApi().then((res) => {
        this.listCooler = res.body.data
      })
    },
    queryCoolers(query) {
      if (query !== '') {
        this.coolerOptions = this.listCooler.filter((item) => {
          return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
        })
      } else {
        this.coolerOptions = []
      }
    },
    addCooler() {
      if (!this.coolerCode) {
        this.$message.warning(`冷藏箱编号不能为空`)
        return
      }
      const index = this.tableData.findIndex((i) => {
        return i.coolerCode == this.coolerCode
      })
      if (index != -1) {
        this.$message.warning(`冷藏箱已经存在当前运单,请删除后重新添加`)
        return
      }
      const loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .carrierWaybillUseCoolerApi({
          dispatchOrderCode: this.dispatchOrderCode,
          coolerCode: this.coolerCode,
        })
        .then((res) => {
          loadingInstance.close()
          this.loadData()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.formData.coolerNo = ''
          this.coolerOptions = []
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    deleteCooler({ coolerCode }) {
      const loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .carrierWaybillDelCoolerApi({
          coolerCode,
          dispatchOrderCode: this.dispatchOrderCode,
        })
        .then((res) => {
          loadingInstance.close()
          this.loadData()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.coolerOptions = []
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  },
}
</script>
